<template>
    <BaseForm v-if="project">
        <template #fields>
            <MultiLink
                :label="$t('other-systems')"
                :links="values.otherSystems"
                :error-messages="errors.otherSystems"
                @input="setFieldValue('otherSystems', $event)"
                @delete="setFieldValue('otherSystems', $event)"
            />
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import BaseForm from '@/components/Form/BaseForm.vue';
import { useMultiLink } from '@/components/MultiLink/composables/useMultiLink';
import MultiLink from '@/components/MultiLink/MultiLink.vue';
import { useForm } from '@/forms/composables/useForm';
import { useProjectInjection } from '@/project/composables/useProjectInjection';
import { ProjectSeriesSystemsSchema } from '@/project/schemas';
import { computed } from 'vue';

defineProps<{ projectId: string }>();

const { project, createProjectMultiLink } = useProjectInjection();
const { getFormFieldLinks, saveMultiLinkFields } = useMultiLink(createProjectMultiLink);

const otherSystemsId = computed(() => project.value?.otherSystems?.id);
const otherSystemsLinks = computed(() => project.value?.otherSystems?.links.nodes ?? []);

const { values, errors, setFieldValue, validate, onDiscard, resetForm } = useForm(
    ProjectSeriesSystemsSchema,
    computed(() => ({
        otherSystems: getFormFieldLinks(otherSystemsLinks),
    })),
);

async function save() {
    const valid = await validate();
    if (valid) {
        await saveMultiLinkFields([
            {
                id: otherSystemsId.value,
                fieldName: 'otherSystems',
                links: values.value.otherSystems,
            },
        ]);
    }
}

defineExpose({ save, onDiscard, resetForm });
</script>
